/**
 * Connection Status Enum
 */
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["CONNECTED"] = "connected";
    ConnectionStatus["WEAK"] = "weak";
    ConnectionStatus["DISCONNECTED"] = "disconnected";
})(ConnectionStatus || (ConnectionStatus = {}));
/**
 * Range thresholds for hunter distance feedback
 */
export const RangeThresholds = {
    FOUND: 5, // Within 5 meters = found
    VERY_CLOSE: 15, // Within 15 meters
    CLOSE: 50, // Within 50 meters
    NEARBY: 150, // Within 150 meters
};
/**
 * Calculate distance between two GPS coordinates using Haversine formula
 */
export function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371000; // Earth's radius in meters
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;
    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}
//# sourceMappingURL=location.js.map